<template>
   <v-form ref="namephoneform" onsubmit="return false;">
        <v-layout row wrap>
            <v-flex xs12>
                <v-text-field
                    outline
                    color="secondary"
                    :label="'Name'"
                    name="name"
                    :placeholder="'Enter your name here'"
                    :rules="[
                        rules.required,
                        rules.min_length(3),
                        rules.max_length(250),
                    ]"
                    counter="250"
                    prepend-inner-icon="lock"
                    type="text"
                    v-model="name"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 mb-4>
                <VuePhoneNumberInput
                    class="custom-input"
                    @update="setPhoneNumber"
                    :no-example="true"
                    :translations="Optionaltranslations"
                    :show-code-on-list="true"
                    :countries-height="30"
                    :default-country-code="country_code"
                    v-model="formattedNumber"
                    size="lg"
                    :dark="darkMode"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import rules from "@/validation";
import i18n from "@/i18n";
import DEFINES from "@/defines";
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from "vuex";

export default {
    name:"NameAndPhone",
    props:{
        country_code:{
            default:DEFINES.DEFAULT_COUNTRY_CODE
        }
    },
    data(){
        return{
            rules,
            name:null,
            formattedNumber:null,
            phone:null,
            Optionaltranslations: {
                phoneNumberLabel: i18n.t("screening.register.lable.phone.optional"),
            },
        }
    },
    components: {
        VuePhoneNumberInput
    },
    computed:{
        ...mapGetters("app", {
            darkMode: "darkMode"
        })
    },
    watch:{
        name(){
            this.$emit("update:name",this.name)
        },
        phone(){
            this.$emit("update:phone",this.phone)
        }
    },
    methods:{
        setPhoneNumber(payload) {
            if (payload.formattedNumber) {
                this.phone = payload.formattedNumber;
            }
        },
        reset() {
            this.$refs.namephoneform.reset();
        },
        validate() {
            return this.$refs.namephoneform.validate();
        },
    }
}
</script>

<style>

</style>
